export default function verifyEmailTokenSyntax(token: string): boolean {
  const parts = token.split(".");
  try {
    JSON.parse(atob(parts[1])); // verify only the payload part of JWT
    return true;
  } catch (error) {
    return false;
  }
}
